import React, { PropsWithChildren } from 'react';

export const TitleText: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<h1 className="text-zinc-100 font-lora text-xl font-medium leading-5 m-0 p-[2px]">{children}</h1>
	);
};
